import axios from "axios";

axios.defaults.withCredentials = true;

export const CART_TOTAL_RESPONSE = "CART_TOTAL_RESPONSE";
export const SET_SELECTED_WARRANTIES = "SET_SELECTED_WARRANTIES";

export function cartTotalResponse(json) {
  return { type: CART_TOTAL_RESPONSE, payload: json.data };
}

export function setSelectedWarranties(warranties) {
  return { type: SET_SELECTED_WARRANTIES, payload: warranties };
}
